// 2D helpers on {x, z} rings, shared by the candidate generators.
const { distanceToLineSegment } = require('../geometry/pointInPolygon');

/** Shoelace signed area. The sign encodes winding, so callers can orient
 * inward normals without assuming CCW/CW input. */
function signedPolygonArea(polygon) {
  let a = 0;
  for (let i = 0; i < polygon.length; i++) {
    const p = polygon[i];
    const q = polygon[(i + 1) % polygon.length];
    a += p.x * q.z - q.x * p.z;
  }
  return a / 2;
}

/** Shortest distance from `point` to any edge of the ring. */
function minDistanceToPolygonEdges(point, polygon) {
  let min = Infinity;
  for (let i = 0; i < polygon.length; i++) {
    const d = distanceToLineSegment(
      point,
      polygon[i],
      polygon[(i + 1) % polygon.length]
    );
    if (d < min) min = d;
  }
  return min;
}

/** Unit inward normal of edge i (corner i → corner i+1), oriented by the
 * ring's winding: pass windingSign = signedPolygonArea(polygon) > 0 ? 1 : -1. */
function inwardEdgeNormal(polygon, i, windingSign) {
  const a = polygon[i];
  const b = polygon[(i + 1) % polygon.length];
  const len = Math.hypot(b.x - a.x, b.z - a.z);
  if (len < 1e-9) return null;
  const ux = (b.x - a.x) / len;
  const uz = (b.z - a.z) / len;
  return { x: -uz * windingSign, z: ux * windingSign };
}

module.exports = {
  signedPolygonArea,
  minDistanceToPolygonEdges,
  inwardEdgeNormal,
};
